export const LIGHT_SKY_BLUE = '#92d4f7';
export const GREY_SUIT = '#938E9F';
export const NERO = '#202020'; // that's really the colors name




//////////////////
// WEBPACK FOOTER
// ./src/constants/colors.js
// module id = 153
// module chunks = 0